import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function AdminSEOPage() {
  const [s, setS] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { (async () => { const { data } = await api.get("/admin/seo/settings"); setS(data || {}); })(); }, []);

  const save = async () => {
    setSaving(true);
    try { await api.put("/admin/seo/settings", s); } finally { setSaving(false); }
  };

  const field = (k, label, placeholder = "") => (
    <label className="block">
      <span className="text-[10px] tracking-overline uppercase text-cc-muted">{label}</span>
      <input value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="cc-input mt-1" placeholder={placeholder} data-testid={`seo-${k}`} />
    </label>
  );

  return (
    <div data-testid="admin-seo">
      <h1 className="font-serif text-4xl text-cc-text mb-2">SEO Ayarları</h1>
      <p className="text-sm text-cc-muted mb-8">Global meta + analytics ID'leri</p>

      <div className="bg-white border border-admin-border p-6 grid md:grid-cols-2 gap-6 mb-8">
        {field("site_title", "Site Başlığı", "Capella Cave — Kapadokya Journal")}
        {field("twitter_handle", "Twitter Handle", "@capellacave")}
        <div className="md:col-span-2">
          <label>
            <span className="text-[10px] tracking-overline uppercase text-cc-muted">Site Açıklaması</span>
            <textarea value={s.site_description || ""} onChange={(e) => setS({ ...s, site_description: e.target.value })} className="cc-input mt-1 min-h-[80px]" data-testid="seo-site_description" />
          </label>
        </div>
        {field("default_og_image_url", "Varsayılan OG Görsel URL")}
      </div>

      <div className="bg-white border border-admin-border p-6 grid md:grid-cols-2 gap-6 mb-8">
        <h3 className="md:col-span-2 font-medium text-cc-text">Analytics & Tracking</h3>
        {field("gtag_id", "Google Analytics (G-...)", "G-XXXXXXXXXX")}
        {field("gsc_verification", "Search Console Verification")}
        {field("clarity_id", "Microsoft Clarity ID")}
        {field("meta_pixel_id", "Meta Pixel ID")}
        {field("gtm_id", "Google Tag Manager (GTM-...)")}
      </div>

      <button onClick={save} disabled={saving} className="cc-btn" data-testid="seo-save">{saving ? "Kaydediliyor…" : "Kaydet"}</button>
    </div>
  );
}
